import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Badge, Card, Space, Statistic, Typography } from 'antd'
import { cloneElement, ReactNode } from 'react'
import { Platform } from '../../models/Platform'

const { Text } = Typography

interface Props {
  platform?: Platform
  currentValue?: number
  prevValue?: number
  title?: ReactNode
  loading?: boolean
  disabled?: boolean
}

export const CountCard = ({
  platform,
  currentValue,
  prevValue,
  title,
  loading,
  disabled,
}: Props) => {
  const content = disabled ? (
    <Card style={{ opacity: 0.5 }}>
      <Statistic
        loading={loading}
        title={title}
        value={'--'}
        prefix={<UserOutlined />}
      />
    </Card>
  ) : (
    <Card>
      <Statistic
        loading={loading}
        title={title}
        value={currentValue ?? '--'}
        prefix={<UserOutlined />}
        suffix={
          currentValue && prevValue !== undefined ? (
            <Statistic
              value={
                prevValue === 0
                  ? '∞'
                  : (
                      (((currentValue ?? 0) - prevValue) /
                        Math.abs(prevValue)) *
                      100
                    ).toFixed(0) + ' %'
              }
              styles={{
                content: {
                  color: prevValue < currentValue ? '#3f8600' : '#fb4c50',
                  fontSize: 14,
                },
              }}
              prefix={
                prevValue < currentValue ? (
                  <ArrowUpOutlined />
                ) : (
                  <ArrowDownOutlined />
                )
              }
            />
          ) : undefined
        }
      />
    </Card>
  )
  return (
    <>
      {platform != undefined ? (
        <Badge.Ribbon
          text={
            <Space size={5}>
              {cloneElement(platform.icon as any, {
                style: {
                  fontSize: 12,
                  color: platform.color[6],
                },
              })}
              <Text
                style={{
                  color: platform.color[6],
                  fontSize: 12,
                }}
              >
                {platform.name}
              </Text>
            </Space>
          }
          color={platform.color[0]}
          style={{
            borderColor: platform.color[2],
            borderWidth: 1,
            borderStyle: 'solid',
            opacity: disabled ? 0.5 : undefined,
          }}
        >
          {content}
        </Badge.Ribbon>
      ) : (
        content
      )}
    </>
  )
}

export default CountCard
